import { createFileRoute } from '@tanstack/react-router'
import { DraftsPage } from '@/features/projects/pages/drafts-page'

export const Route = createFileRoute('/_authenticated/_sidebar/grower/drafts')({
  component: Drafts,
})

function Drafts() {
  return <DraftsPage />
}

